// extracted by mini-css-extract-plugin
module.exports =  {"geosuggest-popup":"_6444e049b8--geosuggest-popup--j8epB","suggestion-list":"_6444e049b8--suggestion-list--NRzbC"};